export default {
  title: {
    id: 'product_page_verified_refurbished_carousel_title',
    defaultMessage: 'Restored professionally',
  },
  subtitle: {
    id: 'product_page_verified_refurbished_carousel_subtitle',
    defaultMessage: '25-point inspection',
  },
  subtitleDynamic: {
    id: 'product_page_verified_refurbished_carousel_subtitle_by_number',
    defaultMessage: '{nb_points}-point inspection',
  },
  prevSlideText: {
    id: 'product_page_verified_refurbished_carousel_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'product_page_verified_refurbished_carousel_next_slide',
    defaultMessage: 'Display next slide',
  },
} as const
